import Modal from "~/common/components/Modal";
import { potentialAreasOfConcern } from "~/providers/utils";
import { PotentialAreasConcernTable } from "../v2/PotentialAreasConcernV2/PotentialAreasConcernTable";

interface PotentialAreasOfConcernModalProps {
  show: boolean;
  onClose: () => void;
}

export const PotentialAreasOfConcernModal = ({
  show,
  onClose,
}: PotentialAreasOfConcernModalProps) => (
  <Modal
    className="h-fit max-h-[80vh] w-auto overflow-y-auto md:min-w-[40.75rem]"
    titleClassName="text-xl font-semibold w-2/3 text-gray-70"
    title="Potential areas of concern"
    show={show}
    onClose={onClose}
  >
    <div className="flex flex-col gap-4 text-gray-700">
      <p className="text-sm">
        The system is designed to flag traits that may suggest characteristic
        behavioral patterns useful for assessing clinical fit.
      </p>
      <PotentialAreasConcernTable
        potentialAreasOfConcern={potentialAreasOfConcern}
      />
    </div>
  </Modal>
);
